// ============================================================================
// Unloading tag — shown wherever an order that needs unloading labour at the
// customer's site surfaces (order list, PO list, operations board, pending
// tasks). Mirrors ExpressTag so the two priority markers read the same way
// across every OMS screen. Signal: a positive "unloading" service charge on the
// estimate (the only durable trace the schema has — there is no operational flag).
// ============================================================================
import { DownloadOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";

const UnloadingTag: React.FC<{ show?: boolean }> = ({ show }) =>
  show ? (
    <Tooltip title="This order carries an unloading charge — unloading labour is needed at the customer's site.">
      <Tag color="volcano" icon={<DownloadOutlined />} style={{ marginInlineEnd: 0 }}>
        unloading
      </Tag>
    </Tooltip>
  ) : null;

export default UnloadingTag;
